export function deepClone<T>(value: T, options?: StructuredSerializeOptions): T {
	return structuredClone(value, options);
}
